import type { NewsArticle } from '../../news/model/types';
import type { NewsItem } from '../../../types/news';
import { htmlToPlainText } from '../../../utils/news';

function toDate(raw?: string | null): string {
    if (!raw) return '';
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return '';
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
}

export function mapNewsHandbookItem(dto: NewsArticle): NewsItem {
    const html = dto.description ?? '';

    const fileLinks = dto.file_links?.length ? dto.file_links : (dto.image_files ?? []);

    return {
        id: dto.id,
        date: toDate(dto.created_at),
        title: dto.title ?? '',
        html,
        paragraphs: htmlToPlainText(html)
            .split('\n')
            .map((line) => line.trim())
            .filter(Boolean),
        imageUrl: fileLinks[0] ?? null,
        fileLinks,
    };
}